module.exports = __webpack_public_path__ + "img/pause.cd7da876.svg";